module.exports = __webpack_public_path__ + "img/instagram.52641eee.svg";